import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { loadGoogleMapsApi } from '@core/maps/google-maps-loader';

loadGoogleMapsApi();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
